export default function registerDistributary (lf) {
  lf.register('distributary', ({ PolygonNode, PolygonNodeModel, h }) => {
    class Node extends PolygonNode {
      getIconShape () {
        const {model} = this.props
        const {x,y,width, height} = model
        const {stroke} = model.getNodeStyle()
        return h(
          "svg",{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink",x:width/2-25,y:height/2-25,"width":"50","height":"50","viewBox":"0 0 40 40","fill":"none"},
          h("g",{"opacity":"1","transform":"translate(0 0)  rotate(0 20 20)"}),
          h("g",{"mask":"url(#bg-mask-0)"}),
          h("path",{"id":"分组 1","fill-rule":"evenodd","style":"fill:#43CF7C","transform":"translate(9.374897692327245 0.0012061875804771915)  rotate(0 11.562551153836395 19.99867824463086)","opacity":"1","d":"M0 35.65C0.02 38.1 2.07 40.08 4.53 39.99C6.88 39.92 8.75 37.99 8.75 35.62C8.75 33.91 7.76 32.42 6.32 31.7C5.89 31.49 5.63 31.06 5.63 30.58L5.63 29.83C5.63 28.19 6.4 26.64 7.75 25.7C7.87 25.61 8 25.53 8.13 25.46C8.88 25.02 9.43 24.97 10.35 24.88C11.14 24.8 12.12 24.7 13.46 24.33C15.44 23.77 18.14 23.02 19.77 20.72C20.71 19.41 21.15 17.79 21.1 15.92C21.09 15.65 21.07 15.38 21.05 15.1C21 14.68 21.18 14.28 21.51 14.01C22.5 13.22 23.13 11.99 23.13 10.62C23.13 8.19 21.13 6.21 18.69 6.25C16.32 6.28 14.39 8.23 14.38 10.6C14.36 12.65 15.77 14.38 17.66 14.86C18.21 15 18.59 15.49 18.61 16.05C18.63 17.12 18.43 18.29 17.73 19.27C16.61 20.85 14.58 21.42 12.79 21.92C11.66 22.24 10.83 22.32 10.11 22.39C9.07 22.49 8.1 22.59 6.88 23.29C6.62 23.44 6.37 23.6 6.13 23.78C5.92 23.94 5.63 23.79 5.63 23.53L5.63 9.42C5.63 8.95 5.89 8.51 6.32 8.3C7.77 7.58 8.77 6.08 8.75 4.35C8.73 1.89 6.68 -0.08 4.22 0C1.88 0.08 0 2.01 0 4.37C0 6.09 0.99 7.58 2.43 8.3C2.86 8.51 3.13 8.94 3.13 9.41L3.13 30.57C3.13 31.05 2.86 31.49 2.43 31.7C0.98 32.42 -0.01 33.92 0 35.65Z M4.3801 6.24879C5.4101 6.24879 6.2501 5.40879 6.2501 4.37879C6.2501 3.33879 5.4101 2.49879 4.3801 2.49879C3.3401 2.49879 2.5001 3.33879 2.5001 4.37879C2.5001 5.40879 3.3401 6.24879 4.3801 6.24879Z M4.3801 33.7488C3.3401 33.7488 2.5001 34.5888 2.5001 35.6288C2.5001 36.6588 3.3401 37.4988 4.3801 37.4988C5.4101 37.4988 6.2501 36.6588 6.2501 35.6288C6.2501 34.5888 5.4101 33.7488 4.3801 33.7488Z M20.6251 10.6288C20.6251 9.58879 19.7851 8.74879 18.7551 8.74879C17.7151 8.74879 16.8751 9.58879 16.8751 10.6288C16.8751 11.6588 17.7151 12.4988 18.7551 12.4988C19.7851 12.4988 20.6251 11.6588 20.6251 10.6288Z "}),
          h("mask",{"id":"bg-mask-0","fill":"white"}),
          h("use",{"xlink:href":"#path_0"}),
          h("rect",{"id":"path_0","x":"0","y":"0","width":"40","height":"40"}),

        )
      }
      getShape () {
        const {model} = this.props
        const {width, height, x, y, points} = model
        const {fill, fillOpacity, strokeWidth, stroke, strokeOpacity,} = model.getNodeStyle()
        const transform = `matrix(1 0 0 1 ${x - width / 2} ${y - height / 2})`
        const pointsPath = points.map(point => point.join(',')).join(' ')
        return h(
          'g',
          {
            transform
          },
          [
            h("svg",{"xmlns":"http://www.w3.org/2000/svg","version":"1.1"}),
            h("rect",{"width":width,"height":height,"style":"fill:#ffffff;stroke-width:1;stroke:#aaaaaa;"}),
            this.getIconShape()
          ]
        )
      }
    }
    class Model extends PolygonNodeModel {
      constructor (data, graphModel) {
        data.text = {
          value: (data.text && data.text.value) || '',
          x: data.x,
          y: data.y + 50
        }
        super(data, graphModel)
        // 右键菜单自由配置，也可以通过边的properties或者其他属性条件更换不同菜单
        this.menu = [
          {
            className: 'lf-menu-delete',
            text: '删除',
            callback (node) {
              // const comfirm = window.confirm('你确定要删除吗？')
              lf.deleteNode(node.id)
            }
          },
          {
            text: '修改',
            className: 'lf-menu-item',
            callback (node) {
              lf.editText(node.id)
            }
          },
          {
            text: '复制',
            className: 'lf-menu-item',
            callback (node) {
              lf.cloneNode(node.id)
            }
          }
        ]
      }
      initNodeData(data) {
        super.initNodeData(data)
        const lenght = 35
        this.points = [
          [lenght, 0],
          [lenght * 2, lenght],
          [lenght, lenght * 2],
          [0, lenght]
        ]
      }
      // 自定义锚点样式
      getAnchorStyle() {
        const style = super.getAnchorStyle();
        style.hover.r = 8;
        style.hover.fill = "rgb(24, 125, 255)";
        style.hover.stroke = "rgb(24, 125, 255)";
        return style;
      }
    }
    return {
      view: Node,
      model: Model
    }
  })
}



// WEBPACK FOOTER //
// ./src/components/Admin/Flow/bpmn/registerNode/registerDistributary.js